import React, {useContext, useState}from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonContent, IonButton, IonImg, IonFooter, IonHeader } from '@ionic/react';
import { Document, Page } from 'react-pdf';
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';


import '../../../../css/qavaApp.css';


export function ViewInvoiceModal(props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [fileLocation, setFileLocation ] = useState(null);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);
    
    let [viewPdf, setViewPDF] = useState(false);

    function closeModalHandler() {

        props.closeModal(false);
    }

    async function openPDF(){
        //window.open(props.data.fileLocation);

        const uriResult = await Filesystem.getUri({
            directory: Directory.Data,
            path: props.data.fileLocation,
          });
    
          // the path to the file
          const path = uriResult.uri;

          alert(path);
    
          // convert to capacitor//
          const localFileURL = Capacitor.convertFileSrc(path);

          alert(localFileURL);
          setFileLocation(localFileURL);

    }

    // function openBroswer(){

    //     //alert( baseURL);
    //     //alert( props.data.fileLocation);
    //     //alert( baseURL+props.data.fileLocation);

    //     Browser.open({ url: baseURL+props.data.fileLocation}).then(() => {});

    // }
    function openBroswer(){

        //alert( baseURL);
        //alert( attachement);
        //alert( baseURL+props.data.fileLocation);
        const timestamp = new Date().getTime(); // Ensures uniqueness
        const url = `${baseURL}${props.data.fileLocation}?t=${timestamp}`;
        Browser.open({ url });
        //Browser.open({ url: baseURL+attachement}).then(() => {});

    }

    //alert('TEST - Inside View Invoice');
    //alert(props.data.fileLocation);
    //alert( baseURL+props.data.fileLocation);


    return (
    <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
            <IonGrid >
                <IonRow>
                    <IonCol> Room ID</IonCol>
                    <IonCol> Price Per Night</IonCol>
                </IonRow>
                <IonRow>
                    <IonCol> {props.data.roomID} </IonCol>
                    <IonCol> {props.data.roomSalePrice} </IonCol>
                </IonRow>
            </IonGrid >
          {/*}  {viewPdf == true &&

            <IonGrid>
                <IonRow>
                    <IonCol>
                    <iframe
                        src={baseURL + props.data.fileLocation}
                        style={{ width: '100%', height: '100vh', backgroundColor: 'black' }}
                    ></iframe>
                    </IonCol>
                </IonRow>
                <IonRow>
                        <IonCol>
                            <IonButton onClick={() => setViewPDF(false)}>View PDF</IonButton>

                        </IonCol>
                    </IonRow>
            </IonGrid>               
             }*/}

        {viewPdf != true && <IonGrid >
                    {/*<IonRow>
                        <IonCol>
                            <IonButton onClick={() => setViewPDF(true)}>View PDF</IonButton>

                        </IonCol>
        </IonRow>*/}
                    <IonRow>
                        <IonCol>
                            <IonButton onClick={openBroswer}>Open PDF</IonButton>
                            {/*<IonButton href={props.data.fileLocation}>View Invoice</IonButton>
                            <IonButton href={baseURL+'fileServer/merchants/bluefin_6569/forms/temp/'+props.data.fileLocation}>View Invoice Href</IonButton>
                            <object data={props.data.fileLocation} type="application/pdf" width='100%' height='100%'>
                                <p>Alternative text - include a link <a href={props.data.fileLocation}>to the PDF!</a></p>
                            </object>
                            <Document file={props.data.fileLocation}>
                                <Page pageNumber='1'></Page>
                            </Document>

                                    <iframe
                                        width='100%'
                                        height='100%'
                                        src={props.data.fileLocation}
                                    >
                                    </iframe>*/}
                        </IonCol>
                    </IonRow>
                </IonGrid>
            }
            <IonFooter className='modal_footer_button_center'>
                <IonButton onClick={closeModalHandler}> Close </IonButton>
            </IonFooter>
        </IonModal>) : null}
    </React.Fragment>
    )
}